import { no } from './translations/no';
import { en } from './translations/en';

export type Language = 'no' | 'en';

export const translations = {
  no,
  en,
} as const;

export type Translations = typeof no;

// Helper to get nested translation value
export function getTranslation(obj: any, path: string): string {
  return path.split('.').reduce((acc, part) => acc?.[part], obj) ?? path;
}
